import {Session} from '@/model/CommonModel.ts';

const KEY_USER_KEY = 'USER_KEY';
const KEY_ACCESS_TOKEN = 'ACCESS_TOKEN';

export default class AppSession {
    public static setUserKey(userKey: number) {
        sessionStorage.setItem(KEY_USER_KEY, userKey.toString());
    }
    
    public static getUserKey(): number | undefined {
        const userKey = sessionStorage.getItem(KEY_USER_KEY);
        return userKey === null ? undefined : parseInt(userKey, 10);
    }
    
    public static getAccessToken(): string | undefined {
        const accessToken = sessionStorage.getItem(KEY_ACCESS_TOKEN);
        return accessToken === null ? undefined : accessToken;
    }
    
    public static setAccessToken(token: string) {
        sessionStorage.setItem(KEY_ACCESS_TOKEN, token);
    }
    
    public static isUserLoggedIn(sponsorKey: string | undefined): boolean {
        return (
            AppSession.getUserKey() !== undefined &&
            AppSession.getAccessToken() !== null &&
            sponsorKey !== undefined
        );
    }
    
    public static setSession(session: Session) {
        const {userKey, token} = session;
        this.setUserKey(userKey);
        this.setAccessToken(token);
    }
    
    public static logout() {
        sessionStorage.clear();
    }
}
